import fr from 'facet-rest';
import Autocomplete from 'Components/UI/Autocomplete';

export const FeatureToggleTableOverride = fr.metaOverride()
  .overrideAll({
    readonly: true,
    _hideLabel: true,
    _customProps: {
      noWrap: true,
      hasTooltip: true,
    },
  })
  .nameOverride('name', { ordinal: 1 })
  .nameOverride('description', { ordinal: 2 })
  .nameOverride('enabled', { ordinal: 3 })
  .nameOverride('activationStrategy', { ordinal: 4 })
  .nameOverride('enabledFor', { ordinal: 5 })
  .nameOverride('groupName', { hidden: true });

export const FeatureToggleCreateOverride = fr.metaOverride()
  .nameOverride('name', { ordinal: 1 })
  .nameOverride('enabled', { ordinal: 2 })
  .nameOverride('activationStrategy', { ordinal: 3 })
  .nameOverride('enabledFor', { ordinal: 4, _component: Autocomplete })
  .nameOverride('description', { ordinal: 5, _customProps: { multiline: true } });

export const FeatureToggleEditOverride = fr.metaOverride()
  .nameOverride('name', { ordinal: 1 })
  .nameOverride('enabled', { ordinal: 2 })
  .nameOverride('activationStrategy', { ordinal: 3 })
  .nameOverride('enabledFor', { ordinal: 4, _component: Autocomplete })
  .nameOverride('description', { ordinal: 5, _customProps: { multiline: true } });
